import styled from 'styled-components'

export const SignupEmailSection = styled.div`
  flex: 1 1 auto;
  // padding: calc(100vh * (51 / 812)) calc(100vw * (36 / 375)) calc(100vh * (60 / 812)) calc(100vw * (30 / 375));
  padding: 0 calc(100vw * (20 / 375));
  height: 100%;
`

export const TitleArea = styled.div`
  margin-top: calc(100vw * (43 / 375));
`

export const Title = styled.h2`
  font-size: calc(100vw * (23 / 375));
  font-weight: 700;
  line-height: calc(100vw * (29 / 375));
  white-space: pre-wrap;
`

export const Description = styled.p`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (20 / 375));
  color: #7f7f7f;
  margin-top: calc(100vw * (8 / 375));
`

export const EmailInputBlock = styled.div`
  position: relative;
  margin-top: calc(100vw * (35 / 375));
`

export const InputStyle = styled.input`
  border: 1px solid #d5d5d5;
  border-radius: calc(100vw * (5 / 375));
  width: 100%;

  padding: calc(100vw * (11 / 375));
  &:focus {
    border: 1px solid #ffcf19;
  }
  &::placeholder {
    font-size: calc(100vw * (14 / 375));
    color: #c6c6c6;
  }
  &.error_active {
    border: 1px solid #de0000;
  }
`

export const DeleteButton = styled.button`
  position: absolute;
  top: 50%;
  right: 5%;
  height: calc(100vw * (18 / 375));
  transform: translate(0, -50%);
`

export const DeleteIcon = styled.img`
  width: calc(100vw * (18 / 375));
`

export const ErrorBlock = styled.div`
  margin-top: calc(100vw * (4 / 375));
`

export const ErrorIcon = styled.img`
  width: calc(100vw * (12 / 375));
  margin-right: calc(100vw * (4.5 / 375));
`

export const ErrorMessage = styled.p`
  display: inline-block;
  font-size: calc(100vw * (10 / 375));
  color: #de0000;
`
